import React from 'react';
import {
  AutocompleteInput,
  BooleanInput,
  Filter,
  ReferenceInput,
  TextInput,
} from 'react-admin';

import { STATUS_ATIVO } from '../../utils/constants';

/**
 * Filtros de busca de produtos da tela de Cartazes de Oferta.
 * Subconjunto de `Resources/Produtos/Filter.js` — só o que faz sentido para
 * encontrar um produto e gerar o cartaz.
 */
const Filtro = (props) => (
  <Filter {...props}>
    <TextInput label="Descrição" source="nome" alwaysOn />
    <TextInput label="Código de barras" source="codigo" alwaysOn />
    <ReferenceInput
      fullWidth
      label="Categoria"
      source="categoria_id"
      reference="categorias"
      sort={{ field: 'nome', order: 'ASC' }}
      filterToQuery={(searchText) => ({ nome: `${searchText}` })}
      perPage={30}
    >
      <AutocompleteInput optionText="nome" />
    </ReferenceInput>
    <ReferenceInput
      fullWidth
      label="Local"
      source="local_id"
      reference="locais_setores"
      sort={{ field: 'nome', order: 'ASC' }}
      filterToQuery={(searchText) => ({ nome: `${searchText}` })}
      filter={{ status: STATUS_ATIVO }}
      perPage={30}
    >
      <AutocompleteInput optionText="nome" />
    </ReferenceInput>
    <ReferenceInput
      fullWidth
      label="Fornecedor"
      source="fornecedor_id"
      reference="fornecedores"
      sort={{ field: 'nome', order: 'ASC' }}
      filterToQuery={(searchText) => ({ nome: `${searchText}` })}
      filter={{ status: STATUS_ATIVO }}
      perPage={30}
    >
      <AutocompleteInput optionText="nome" />
    </ReferenceInput>
    <BooleanInput label="No Jornal de Ofertas" source="no_jornal" />
  </Filter>
);

export default Filtro;
